'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import { isBlock } from '../../dom/index.js';
import { DEFAULT_BLOCK_ELEMENT } from '../../dom/parseBlockAttributes.js';
import { useBlock } from './hooks/index.js';
import { useBlockAttributes } from './hooks/useBlockAttributes.js';
/**
 * The CodeBlock component implements block parsing for the core/code block.
 *
 * This component must be used within a {@link BlocksRenderer} component.
 *
 * ```tsx
 * <BlocksRenderer html={html}>
 * 	<CodeBlock component={DebugComponent} />
 * </BlocksRenderer>
 * ```
 *
 * @category Blocks
 *
 * @param props Component properties
 */
export function CodeBlock({ domNode: node = DEFAULT_BLOCK_ELEMENT, children, component: Component, style, }) {
    const { name, className } = useBlock(node);
    const blockAttributes = useBlockAttributes(node);
    return (_jsx(Component, { name: name, domNode: node, className: className, attributes: blockAttributes, style: style, children: children }));
}
/**
 * @internal
 */
// eslint-disable-next-line no-redeclare
(function (CodeBlock) {
    CodeBlock.defaultProps = {
        test: (node) => isBlock(node, { tagName: 'pre', className: 'wp-block-code' }),
    };
})(CodeBlock || (CodeBlock = {}));
